/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PublicMatchOperationV2Event } from './PublicMatchOperationV2Event';
import {
    PublicMatchOperationV2EventFromJSON,
    PublicMatchOperationV2EventFromJSONTyped,
    PublicMatchOperationV2EventToJSON,
    PublicMatchOperationV2EventToJSONTyped,
} from './PublicMatchOperationV2Event';

/**
 * 
 * @export
 * @interface PublicMatchOperationV2EventPage
 */
export interface PublicMatchOperationV2EventPage {
    /**
     * 
     * @type {number}
     * @memberof PublicMatchOperationV2EventPage
     */
    fromRevision: number;
    /**
     * 
     * @type {number}
     * @memberof PublicMatchOperationV2EventPage
     */
    toRevision: number;
    /**
     * 
     * @type {number}
     * @memberof PublicMatchOperationV2EventPage
     */
    streamRevision: number;
    /**
     * 
     * @type {Array<PublicMatchOperationV2Event>}
     * @memberof PublicMatchOperationV2EventPage
     */
    events: Array<PublicMatchOperationV2Event>;
}

/**
 * Check if a given object implements the PublicMatchOperationV2EventPage interface.
 */
export function instanceOfPublicMatchOperationV2EventPage(value: object): value is PublicMatchOperationV2EventPage {
    if (!('fromRevision' in value) || value['fromRevision'] === undefined) return false;
    if (!('toRevision' in value) || value['toRevision'] === undefined) return false;
    if (!('streamRevision' in value) || value['streamRevision'] === undefined) return false;
    if (!('events' in value) || value['events'] === undefined) return false;
    return true;
}

export function PublicMatchOperationV2EventPageFromJSON(json: any): PublicMatchOperationV2EventPage {
    return PublicMatchOperationV2EventPageFromJSONTyped(json, false);
}

export function PublicMatchOperationV2EventPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicMatchOperationV2EventPage {
    if (json == null) {
        return json;
    }
    return {
        
        'fromRevision': json['fromRevision'],
        'toRevision': json['toRevision'],
        'streamRevision': json['streamRevision'],
        'events': ((json['events'] as Array<any>).map(PublicMatchOperationV2EventFromJSON)),
    };
}

export function PublicMatchOperationV2EventPageToJSON(json: any): PublicMatchOperationV2EventPage {
    return PublicMatchOperationV2EventPageToJSONTyped(json, false);
}

export function PublicMatchOperationV2EventPageToJSONTyped(value?: PublicMatchOperationV2EventPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fromRevision': value['fromRevision'],
        'toRevision': value['toRevision'],
        'streamRevision': value['streamRevision'],
        'events': ((value['events'] as Array<any>).map(PublicMatchOperationV2EventToJSON)),
    };
}

